import { TimeService } from '@festina/moneyout-general-types/moneyout-test/services/TimeService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method = TimeService.timeServicePostSetTime
type MethodParam = Parameters<typeof method>[0]

export const useSubmitMoneyOutTime = () =>
  useFestinaMutation({
    component: 'moneyOut',
    isScenario: false,
    roles: TimeService.timeServicePostSetTime_roles,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ ...arg }),
  })
